<template>
  <div class="fill-height">
    <v-dialog v-model="dialogShowCurriculum" fullscreen scrollable>
      <v-card v-if="selectApplicant" tile elevation="0">
        <v-card-title class="display-1">
          <div>
            <span class="mr-4 font-weight-light">Hoja de vida</span>
            <span v-if="selectApplicant.postulante.documentos">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <a
                    style="text-decoration: none"
                    :href="selectApplicant.postulante.documentos.documento"
                    :download="selectApplicant.postulante.documentos.nombre"
                    target="_blank"
                  >
                    <v-btn v-on="on" class="ml-2" icon>
                      <v-icon>mdi-file-download</v-icon>
                    </v-btn>
                  </a>
                </template>
                <span>Descargar certificados</span>
              </v-tooltip>
            </span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="ml-2"
                  icon
                  :to="{ name: 'administrator notices print curriculum applicant', params: { aviso: id, postulante: selectApplicant.postulante._id } }"
                  target="_blank"
                >
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </template>
              <span>Imprimir hoja de vida</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="ml-2"
                  icon
                  :color="!!showCartaPostulacion ? 'primary' : ''"
                  @click="showCartaPostulacion = showCartaPostulacion === '' ? 'Carta postulación' : ''"
                >
                  <v-icon>mdi-comment-text</v-icon>
                </v-btn>
              </template>
              <span>Carta postulación</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="ml-2"
                  icon
                  :color="!!showPreguntas ? 'primary' : ''"
                  @click="showPreguntas = showPreguntas === '' ? 'Preguntas' : ''"
                >
                  <v-icon>mdi-forum</v-icon>
                </v-btn>
              </template>
              <span>Preguntas</span>
            </v-tooltip>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="dialogShowCurriculum = false; showCartaPostulacion = ''; showPreguntas = ''"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="mt-4 error--text" v-if="requirementsItMeets()">
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="error">mdi-alert-circle</v-icon>
              <span class="font-weight-bold title">Requisitos que no cumple</span>
            </div>
            <div v-html="requirementsItMeets()" class="mt-1 ml-8"></div>
            <v-divider class="mt-4"></v-divider>
          </div>
          <v-content v-if="showPreguntas" class="pt-6 pb-0">
            <v-container class="py-0">
              <v-row>
                <v-col cols="4" class="py-0 d-flex align-center justify-start">
                  <v-btn icon color="error" class="mr-4" @click="showPreguntas = ''">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <div class="display-1 font-weight-bold my-4">{{ showPreguntas }}</div>
                </v-col>
                <v-col class="py-0">
                  <v-container class="py-0">
                    <v-row>
                      <v-col class="py-0">
                        <div>
                          <div v-for="(pregunta, index) of selectApplicant.preguntas" :key="index">
                            <div class="font-weight-bold mb-1">{{ pregunta.pregunta }}</div>
                            <p class="mb-5">{{ pregunta.respuesta }}</p>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
            <v-divider></v-divider>
          </v-content>
          <v-content v-if="showCartaPostulacion" class="pt-2">
            <v-container class="py-0">
              <v-row>
                <v-col cols="4" class="py-0 d-flex align-center justify-start">
                  <v-btn icon color="error" class="mr-4" @click="showCartaPostulacion = ''">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <div class="display-1 font-weight-bold my-4">{{ showCartaPostulacion }}</div>
                </v-col>
                <v-col class="py-0">
                  <v-container class="py-0">
                    <v-row>
                      <v-col class="py-0">
                        <div
                          class="title font-weight-light my-4"
                        >{{ selectApplicant.carta_postulacion }}</div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
            <v-divider></v-divider>
          </v-content>
          <Curriculum
            ref="print-curriculum"
            v-if="selectApplicant"
            :curriculum="selectApplicant.postulante"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container v-if="loading" class="fill-height pa-0 align-start" fluid>
      <v-progress-linear indeterminate></v-progress-linear>
    </v-container>
    <v-container
      v-else
      :fluid="$vuetify.breakpoint.lgAndDown"
      class="px-8 py-2 accent fill-height align-content-start"
    >
      <v-row>
        <v-col class="d-flex flex-wrap align-center">
          <BaseMyButtonDirection
            direction="left"
            :animate="true"
            :to="{ name: 'administrator companies notices', params: { id: this.$route.params.empresa } }"
          ></BaseMyButtonDirection>
          <p class="display-1 font-weight-thin ml-4 mb-0" v-text="notice.titulo"></p>
        </v-col>
      </v-row>
      <v-row v-if="notice.requerimientos">
        <v-col class="pb-0 font-weight-bold">Requerimientos</v-col>
      </v-row>
      <v-row v-if="notice.requerimientos">
        <v-col class="pt-1">
          <v-chip-group v-model="filterRequirements" column multiple>
            <v-chip
              v-if="notice.requerimientos.edad"
              :color="`purple ${!filterIsActive('edad') ? 'lighten-5' : ''}`"
              :class="[`${!filterIsActive('edad') ? 'purple--text' : 'white--text'}`, 'mr-2', 'mb-2']"
              label
              value="edad"
            >
              <v-icon small class="mr-2">mdi-cake-variant</v-icon>
              Edad entre {{ notice.requerimientos.edad.edad_min }} y {{ notice.requerimientos.edad.edad_max }}
            </v-chip>
            <v-chip
              v-if="notice.requerimientos.sexo && notice.requerimientos.sexo.sexo"
              :color="`pink ${!filterIsActive('sexo') ? 'lighten-5' : ''}`"
              :class="[`${!filterIsActive('sexo') ? 'pink--text' : 'white--text'}`, 'mr-2', 'mb-2']"
              label
              value="sexo"
            >
              <v-icon small class="mr-2">mdi-gender-male-female</v-icon>
              Género {{ notice.requerimientos.sexo.sexo }}
            </v-chip>
            <v-chip
              v-if="notice.requerimientos.educacion"
              :color="`brown ${!filterIsActive('educacion') ? 'lighten-5' : ''}`"
              :class="[`${!filterIsActive('educacion') ? 'brown--text' : 'white--text'}`, 'mr-2', 'mb-2']"
              label
              value="educacion"
            >
              <v-icon small class="mr-2">mdi-school</v-icon>
              {{ notice.requerimientos.educacion.nivel_educativo }} {{ notice.requerimientos.educacion.estado }}
            </v-chip>
            <v-chip
              v-if="notice.requerimientos.experiencia"
              :color="`teal ${!filterIsActive('experiencia') ? 'lighten-5' : ''}`"
              :class="[`${!filterIsActive('experiencia') ? 'teal--text' : 'white--text'}`, 'mr-2', 'mb-2']"
              label
              value="experiencia"
            >
              <v-icon small class="mr-2">mdi-briefcase</v-icon>
              Experiencia de {{ notice.requerimientos.experiencia.experiencia_minima }} años en {{ notice.area }}
            </v-chip>
            <div v-if="notice.requerimientos.idiomas && notice.requerimientos.idiomas.length">
              <v-chip
                v-for="(idioma, index) of notice.requerimientos.idiomas"
                :color="`info ${!filterIsActive(`idiomas:${index}`) ? 'lighten-5' : ''}`"
                :class="[`${!filterIsActive(`idiomas:${index}`) ? 'info--text' : 'white--text'}`, 'mr-2', 'mb-2']"
                label
                :value="`idiomas:${index}`"
              >
                <v-icon small class="mr-2">mdi-translate</v-icon>
                {{ idioma.idioma }} {{ idioma.nivel }}
              </v-chip>
            </div>
            <v-chip
              v-if="notice.requerimientos.salario"
              :color="`success ${!filterIsActive('salario') ? 'lighten-5' : ''}`"
              :class="[`${!filterIsActive('salario') ? 'success--text' : 'white--text'}`, 'mr-2', 'mb-2']"
              label
              value="salario"
            >
              <v-icon small class="mr-2">mdi-currency-usd</v-icon>
              Salario entre {{ notice.requerimientos.salario.salario_min }} y {{ notice.requerimientos.salario.salario_max }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <span class="mr-2 grey--text">Total hojas de vidas:</span>
          <span class="font-weight-bold mr-1 info--text">{{ filterApplicants.length }}</span>
          <span class="mr-1 grey--text">de</span>
          <span class="font-weight-bold mr-1 info--text">{{ notice.postulantes.length }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex flex-wrap">
          <CardApplicant
            v-for="postulante in filterApplicants"
            :key="postulante._id"
            :applicant="postulante"
            :requerimientos="notice.requerimientos"
            :aviso="{ area: notice.area }"
            class="mb-4"
            width="300"
            max-width="300"
            @click="seeCurriculum(postulante)"
            @favorite="favorite"
            @contratar="contratar"
            :loading="updatedApplicant && updatedApplicant._id === postulante._id"
            :disabled="updatedApplicant && updatedApplicant._id === postulante._id"
          ></CardApplicant>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import CardApplicant from "@/components/CardApplicant";
import Curriculum from "@/components/Curriculum";
import { windowSizeMixin } from "@/mixin/windowSizeMixin.js";
import store from "@/store";

export default {
  name: "CompanyNoticeDetail",
  mixins: [windowSizeMixin],
  components: {
    CardApplicant,
    Curriculum
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      filterRequirements: [],
      updatedApplicant: undefined,
      notice: undefined,
      dialogShowCurriculum: false,
      selectApplicant: undefined,
      showPreguntas: "",
      showCartaPostulacion: ""
    };
  },
  computed: {
    filterApplicants() {
      return this.notice.postulantes.filter(postulante => {
        if (!this.filterRequirements.length) return postulante;
        let isValid = true;
        this.filterRequirements.forEach(filter => {
          const filterRequirement = this.notice.requerimientos[filter];
          if (filter.includes("idiomas")) {
            const filterSplit = filter.split(":");
            const key = filterSplit[0];
            const index = filterSplit[1];

            const languageLevel = {
              Básico: 0,
              Intermedio: 1,
              Avanzado: 2,
              Nativo: 3
            };

            const idiomaFilter = this.notice.requerimientos[key][index];
            const lenguage = postulante.postulante.idiomas.find(
              language => language.idioma === idiomaFilter.idioma
            );

            const lenguageValid =
              lenguage &&
              (languageLevel[lenguage.nivel_oral] >=
                languageLevel[idiomaFilter.nivel] ||
                languageLevel[lenguage.nivel_escrito] >=
                  languageLevel[idiomaFilter.nivel]);

            if (!lenguageValid) isValid = false;
          } else if (
            filter === "edad" &&
            (this.getAge(
              postulante.postulante.informacion_personal.fecha_nacimiento
            ) <= filterRequirement.edad_min ||
              this.getAge(
                postulante.postulante.informacion_personal.fecha_nacimiento
              ) >= filterRequirement.edad_max)
          )
            isValid = false;
          else if (
            filter === "sexo" &&
            postulante.postulante.informacion_personal.genero !==
              filterRequirement.sexo
          )
            isValid = false;
          else if (
            filter === "educacion" &&
            !postulante.postulante.educacion.find(
              educacion =>
                educacion.tipo_estudio === filterRequirement.nivel_educativo &&
                educacion.estado === filterRequirement.estado
            )
          )
            isValid = false;
          else if (
            filter === "experiencia" &&
            !postulante.postulante.experiencia_laborales.find(
              work =>
                work.area_puesto === this.notice.area &&
                this.$moment(work.fecha_fin || new Date()).diff(
                  work.fecha_inicio,
                  "years"
                ) >= filterRequirement.experiencia_minima
            )
          )
            isValid = false;
          else if (
            (filter === "salario" &&
              postulante.salario_pretendido < filterRequirement.salario_min) ||
            postulante.salario_pretendido > filterRequirement.salario_max
          )
            isValid = false;
        });
        return isValid ? postulante : false;
      });
    },
    age() {
      if (!this.selectApplicant || !this.selectApplicant.postulante.informacion_personal.fecha_nacimiento) return '';
      return this.$moment().diff(this.selectApplicant.postulante.informacion_personal.fecha_nacimiento, "years");
    }
  },
  created() {
    this.retrieveNotice();
  },
  methods: {
    retrieveNotice() {
      this.loading = true;
      store
        .dispatch("administration/notices/retrieveNoticeById", { id: this.id, empresa: this.$route.params.empresa})
        .then(notice => {
          this.notice = notice;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    favorite(postulante) {
      this.updatePostulants(postulante, {
        es_favorito: !postulante.es_favorito
      });
    },
    contratar(postulante) {
      this.updatePostulants(postulante, {
        fue_contratado: !postulante.fue_contratado
      });
    },
    seeCurriculum(postulante) {
      if (!postulante.curriculum_leido) {
        this.updatePostulants(postulante, { curriculum_leido: true });
      }
      this.selectApplicant = postulante;
      this.dialogShowCurriculum = true;
    },
    updatePostulants(postulante, dataUpdated) {
      this.updatedApplicant = postulante;
      const data = {
        aviso: this.id,
        postulante: postulante.postulante._id,
        data: dataUpdated,
        empresa: this.$route.params.empresa,
      };

      store
        .dispatch("administration/notices/updatePostulants", data)
        .then(response => {
          const indexPostulant = this.notice.postulantes.findIndex(
            postulanteFinded => postulanteFinded._id === postulante._id
          );

          Vue.set(this.notice.postulantes, indexPostulant, {
            ...this.notice.postulantes[indexPostulant],
            ...data.data
          });
        })
        .finally(() => {
          this.updatedApplicant = undefined;
        });
    },
    getFormatDate(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    getAge(fechaNacimiento) {
      if (!fechaNacimiento) return "";
      return this.$moment().diff(fechaNacimiento, "years");
    },
    filterIsActive(filter) {
      return this.filterRequirements.includes(filter);
    },
    requirementsItMeets() {
      let message = '';
      if (!this.notice.requerimientos) return '';

      let fulfillEducation;
      if (this.notice.requerimientos.educacion) {
        fulfillEducation = this.selectApplicant.postulante.educacion
          .find(educacion => educacion.tipo_estudio === this.notice.requerimientos.educacion.nivel_educativo
            && educacion.estado === this.notice.requerimientos.educacion.estado);
      }

      let fulfillWorkExperience;
      if (this.notice.requerimientos.experiencia) {
        fulfillWorkExperience = this.selectApplicant.postulante.experiencia_laborales
          .find(work => work.area_puesto === this.notice.area
          && this.$moment(work.fecha_fin || new Date()).diff(work.fecha_inicio, 'years') >= this.notice.requerimientos.experiencia.experiencia_minima);
      }

      const languageLevel = {
        'Básico': 0,
        'Intermedio': 1,
        'Avanzado': 2,
        'Nativo': 3,
      }

      let fulfillLanguage;
      if (this.notice.requerimientos.idiomas) {
        fulfillLanguage = this.notice.requerimientos.idiomas
          .every(idioma => {
            const lenguage = this.selectApplicant.postulante.idiomas.find(language => language.idioma === idioma.idioma);
            return lenguage
              && (languageLevel[lenguage.nivel_escrito] >= languageLevel[idioma.nivel]
               || languageLevel[lenguage.nivel_escrito] >= languageLevel[idioma.nivel]);
          });
      }
      
      if (this.notice.requerimientos.edad && (this.age <= this.notice.requerimientos.edad.edad_min || this.age >= this.notice.requerimientos.edad.edad_max)) message += '<div>No cumple con el rango de edad solicitado</div>';
      if (this.notice.requerimientos.sexo && this.notice.requerimientos.sexo.sexo && this.selectApplicant.postulante.informacion_personal.genero !== this.notice.requerimientos.sexo.sexo) message += '<div>No cumple con el género solicitado</div>';
      if (this.notice.requerimientos.educacion && !fulfillEducation) message += '<div>No cumple con el nivel educativo solicitado</div>';
      if (this.notice.requerimientos.experiencia && !fulfillWorkExperience) message += '<div>No cumple con la experiencia laboral en el área indicada</div>';
      if (this.notice.requerimientos.idiomas && this.notice.requerimientos.idiomas.length && !fulfillLanguage) message += '<div>No cumple con el nivel de conocimientos mínimos solicitados</div>';
      if (this.notice.requerimientos.salario && (this.selectApplicant.salario_pretendido < this.notice.requerimientos.salario.salario_min || this.selectApplicant.salario_pretendido > this.notice.requerimientos.salario.salario_max)) message += '<div>El salario pretendido no cumple con el rango establecido</div>';
      return message;
    }
    // requirementsItMeets() {
    //   let message = "";
    //   if (!this.notice.requerimientos) return "";

    //   let fulfillEducation;
    //   if (this.notice.requerimientos.educacion) {
    //     const fulfillEducation = this.selectApplicant.postulante.educacion.find(
    //       educacion =>
    //         educacion.tipo_estudio ===
    //           this.notice.requerimientos.educacion.nivel_educativo &&
    //         educacion.estado === this.notice.requerimientos.educacion.estado
    //     );
    //   }

    //   let fulfillWorkExperience;
    //   if (this.notice.requerimientos.experiencia) {
    //     const fulfillWorkExperience = this.selectApplicant.postulante.experiencia_laborales.find(
    //       work =>
    //         work.area_puesto === this.notice.area &&
    //         this.$moment(work.fecha_fin || new Date()).diff(
    //           work.fecha_inicio,
    //           "years"
    //         ) >= this.notice.requerimientos.experiencia.experiencia_minima
    //     );
    //   }

    //   const languageLevel = {
    //     Básico: 0,
    //     Intermedio: 1,
    //     Avanzado: 2,
    //     Nativo: 3
    //   };

    //   let fulfillLanguage;
    //   if (this.notice.requerimientos.idiomas) {
    //     const fulfillLanguage = this.notice.requerimientos.idiomas.every(
    //       idioma => {
    //         const lenguage = this.selectApplicant.postulante.idiomas.find(
    //           language => language.idioma === idioma.idioma
    //         );
    //         return (
    //           lenguage &&
    //           (languageLevel[lenguage.nivel_escrito] >=
    //             languageLevel[idioma.nivel] ||
    //             languageLevel[lenguage.nivel_escrito] >=
    //               languageLevel[idioma.nivel])
    //         );
    //       }
    //     );
    //   }

    //   if (
    //     this.notice.requerimientos.edad &&
    //     (this.age <= this.notice.requerimientos.edad.edad_min ||
    //       this.age >= this.notice.requerimientos.edad.edad_max)
    //   )
    //     message += "<div>No cumple con el rango de edad solicitado</div>";
    //   if (
    //     this.notice.requerimientos.sexo &&
    //     this.notice.requerimientos.sexo.sexo &&
    //     this.selectApplicant.postulante.informacion_personal.genero !==
    //       this.notice.requerimientos.sexo.sexo
    //   )
    //     message += "<div>No cumple con el género solicitado</div>";
    //   if (this.notice.requerimientos.educacion && !fulfillEducation)
    //     message += "<div>No cumple con el nivel educativo solicitado</div>";
    //   if (this.notice.requerimientos.experiencia && !fulfillWorkExperience)
    //     message +=
    //       "<div>No cumple con la experiencia laboral en el área indicada</div>";
    //   if (this.notice.requerimientos.idiomas && !fulfillLanguage)
    //     message +=
    //       "<div>No cumple con el nivel de conocimientos mínimos solicitados</div>";
    //   if (
    //     this.notice.requerimientos.salario &&
    //     (this.selectApplicant.salario_pretendido <
    //       this.notice.requerimientos.salario.salario_min ||
    //       this.selectApplicant.salario_pretendido >
    //         this.notice.requerimientos.salario.salario_max)
    //   )
    //     message +=
    //       "<div>El salario pretendido no cumple con el rango establecido</div>";
    //   return message;
    // }
  }
};
</script>

<style>
</style>